/** feedback_user_type values reported to BI (catalog: owner/client). */
export const FEEDBACK_USER_TYPE = {
  OWNER: 'owner',
  CLIENT: 'client',
} as const;

/** click_type values for the getFeedbackGenericClick event. */
export const BI_CLICK = {
  // Comment lifecycle
  COMMENT_ADD: 'comment_add',
  COMMENT_EDIT: 'comment_edit',
  COMMENT_DELETE: 'comment_delete',
  COMMENT_RESOLVE: 'comment_resolve',
  COMMENT_REOPEN: 'comment_reopen',
  REPLY_ADD: 'reply_add',
  REPLY_DELETE: 'reply_delete',
  EMOJI_SELECT: 'emoji_select',
  // Toolbar / viewport
  MODE_TOGGLE: 'mode_toggle',
  DEVICE_SWITCH: 'device_switch',
  VIEW_TOGGLE: 'view_toggle',
  SIDEBAR_TOGGLE: 'sidebar_toggle',
  ZOOM_IN: 'zoom_in',
  ZOOM_OUT: 'zoom_out',
  ZOOM_RESET: 'zoom_reset',
  FULLSCREEN: 'fullscreen',
  SHARE_LINK: 'share_link',
  // Sidebar
  SIDEBAR_PIN_CLICK: 'sidebar_pin_click',
  SIDEBAR_SORT: 'sidebar_sort',
  SIDEBAR_CLOSE: 'sidebar_close',
  // User / guest
  GUEST_USER_SUBMIT: 'guest_user_submit',
} as const;

export type BiClick = (typeof BI_CLICK)[keyof typeof BI_CLICK];
